// src/components/forms/pending-orders/PendingOrdersAdditionalInfo.tsx
// Componente para la sección de Información Adicional

import React from 'react'
import type { PendingOrderFormData, OrderDetail } from '../../../types/pendingOrdersFormTypes'
import { Input, Textarea } from '../../ui'
import { FormField } from '../../ui/Form'
import SectionTitle from '../../ui/SectionTitle'
import { InformationCircleIcon, ChevronDownIcon } from '@heroicons/react/24/outline'

interface PendingOrdersAdditionalInfoProps {
  formData: PendingOrderFormData
  orderDetail?: OrderDetail | null
  isExpanded: boolean
  onToggleExpanded: () => void
  onInputChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => void
}

export const PendingOrdersAdditionalInfo: React.FC<PendingOrdersAdditionalInfoProps> = ({
  formData,
  orderDetail,
  isExpanded,
  onToggleExpanded,
  onInputChange
}) => {
  return (
    <div className="bg-white p-6 rounded-lg shadow">
      <div 
        className="flex justify-between items-center cursor-pointer"
        onClick={onToggleExpanded}
      >
        <SectionTitle icon={InformationCircleIcon} noMargin>Información Adicional</SectionTitle>
        <ChevronDownIcon className={`w-6 h-6 transform transition-transform duration-200 ${isExpanded ? 'rotate-180' : ''}`} />
      </div>
      <div className={`grid grid-cols-1 md:grid-cols-2 gap-4 transition-all duration-200 ${isExpanded ? 'mt-4' : 'hidden'}`}>
        <div className="hidden">
          <FormField label="Texto en Guía">
            <Input
              type="text"
              name="texto_guia"
              value={formData.texto_guia}
              onChange={onInputChange}
              mode="edit"
            />
          </FormField>
        </div>
        <FormField label="Notas">
          <Textarea
            name="accion_notaguia"
            value={formData.accion_notaguia || orderDetail?.extraDetails?.customer_note}
            onChange={onInputChange}
            rows={2}
            mode="edit"
          />
        </FormField>
        <div className="hidden">
          <FormField label="Centro de Costo">
            <Input
              type="text"
              name="centrocosto"
              value=""
              readOnly
              mode="view"
            />
          </FormField>
        </div>
      </div>
    </div>
  )
}

